// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-lightbox {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  background: rgba(8, 10, 14, 0.88);
}

.image-lightbox-close {
  position: fixed;
  top: 18px;
  right: 18px;
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  cursor: pointer;
}

.image-lightbox-figure {
  display: grid;
  gap: 14px;
  max-width: min(1200px, 94vw);
  max-height: 92vh;
  margin: 0;
}

.image-lightbox-figure img {
  display: block;
  max-width: 100%;
  max-height: 78vh;
  object-fit: contain;
  border-radius: 8px;
  background: #111;
}

.image-lightbox-figure figcaption {
  display: grid;
  gap: 4px;
  max-width: 900px;
  color: #fff;
  line-height: 1.45;
}

.image-lightbox-figure figcaption span {
  color: #d9dde4;
}

@media (max-width: 640px) {
  .image-lightbox {
    padding: 14px;
  }

  .image-lightbox-close {
    top: 10px;
    right: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ImageLightbox.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":[".image-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 3000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  background: rgba(8, 10, 14, 0.88);\n}\n\n.image-lightbox-close {\n  position: fixed;\n  top: 18px;\n  right: 18px;\n  min-height: 40px;\n  padding: 0 16px;\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n  cursor: pointer;\n}\n\n.image-lightbox-figure {\n  display: grid;\n  gap: 14px;\n  max-width: min(1200px, 94vw);\n  max-height: 92vh;\n  margin: 0;\n}\n\n.image-lightbox-figure img {\n  display: block;\n  max-width: 100%;\n  max-height: 78vh;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #111;\n}\n\n.image-lightbox-figure figcaption {\n  display: grid;\n  gap: 4px;\n  max-width: 900px;\n  color: #fff;\n  line-height: 1.45;\n}\n\n.image-lightbox-figure figcaption span {\n  color: #d9dde4;\n}\n\n@media (max-width: 640px) {\n  .image-lightbox {\n    padding: 14px;\n  }\n\n  .image-lightbox-close {\n    top: 10px;\n    right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
